import {
  buildDeserializer,
  buildSerializer,
  SerializeMap,
} from "lib/serializerUtils";

export const bankingDetailsSerializeMap: SerializeMap<BankingDetails> = {
  accountName: "account_name",
  accountNumber: "account_number",
  bsb: "bsb",
  chequePayableTo: "cheque_payable_to",
  payid: "payid",
  id: "id",
};

const DEFAULT_BANKING_DETAILS = {
  accountName: "",
  accountNumber: "",
  bsb: "",
  chequePayableTo: "",
  payid: "",
} as BankingDetails;

export const deserializeBankingDetails = buildDeserializer(
  bankingDetailsSerializeMap,
  "bankingDetails",
  null,
  DEFAULT_BANKING_DETAILS,
);

export const serializeBankingDetails = buildSerializer(
  bankingDetailsSerializeMap,
  "bankingDetails",
  null,
);
